import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
      meta: {
        title: '启动页'
      }
    },
    {
      path: '/awardactivity/rulepage',
      name: 'awardactivityrulepage',
      component: () => import('@/views/award-activity/rule-page.vue'),
      meta: {
        title: '活动规则'
      }
    },
    {
      path: '/inquire',
      name: 'inquire',
      component: () => import('@/views/inquire-page'),
      meta: {
        title: '防伪溯源'
      }
    },
    {
      path: '/authenticate',
      name: 'authenticate',
      component: () => import('@/views/inquire-page/authenticate-page'),
      meta: {
        title: '防伪码对照'
      }
    },
    {
      path: '/inquirelog',
      name: 'inquirelog',
      component: () => import('@/views/inquire-page/inquire-log'),
      meta: {
        title: '扫码记录'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user-possession'),
      meta: {
        title: '用户积分'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        title: '门店手机号注册'
      }
    },
    {
      path: '/storeregister',
      name: 'storeregister',
      component: () => import('@/views/login/store-register'),
      meta: {
        title: '门店信息注册'
      }
    },
    {
      path: '/merchants',
      name: 'merchants',
      component: () => import('@/views/merchants-page'),
      meta: {
        title: '门店信息'
      },
      redirect: '/performance',
      children: [
        {
          path: '/performance',
          name: 'performance',
          component: () => import('@/views/merchants-page/performance')
        },
        {
          path: '/myearnings',
          name: 'myearnings',
          component: () => import('@/views/merchants-page/my-earnings')
        },
        {
          path: '/ticketrecords',
          name: 'ticketrecords',
          component: () => import('@/views/merchants-page/ticket-records')
        },
        {
          path: '/prizeexchange',
          name: 'prizeexchange',
          component: () => import('@/views/merchants-page/prize-exchange')
        },
        {
          path: '/prizeexchangever',
          name: 'prizeexchangever',
          component: () => import('@/views/merchants-page/prize-remit')
        },
      ]
    },
    {
      path: '/earningsinfo',
      name: 'earningsinfo',
      component: () => import('@/views/merchants-page/earnings-info'),
      meta: {
        title: '门店返利记录'
      }
    },
    {
      path: '/merchantsaudit',
      name: 'merchantsaudit',
      component: () => import('@/views/tips-page/merchants-audit'),
      meta: {
        title: '门店审核中'
      }
    },
    {
      path: '/prizeconfirm',
      name: 'prizeconfirm',
      component: () => import('@/views/merchants-page/prize-confirm'),
      meta: {
        title: '门店中间信息'
      }
    },
    {
      path: '/prizeinfo',
      name: 'prizeinfo',
      component: () => import('@/views/award-activity/prize-info'),
      meta: {
        title: '用户奖品二维码'
      }
    },
    {
      path: '/401',
      name: '401',
      component: () => import('@/views/tips-page/401'),
      meta: {
        title: '信息失效'
      }
    },
    {
      path: '/salesman',
      name: 'salesman',
      component: () => import('@/views/salesman'),
      meta: {
        title: '业务员工作台'
      }
    },
    {
      path: '/storeremit',
      name: 'storeremit',
      component: () => import('@/views/salesman/store-remit'),
      meta: {
        title: '核销待审核'
      }
    },
    {
      path: '/merchantdetails',
      name: 'merchantdetails',
      component: () => import('@/views/salesman/merchant-details'),
      meta: {
        title: '核销信息'
      }
    },
    {
      path: '/marchantsearnings',
      name: 'marchantsearnings',
      component: () => import('@/views/salesman/marchants-earnings'),
      meta: {
        title: '门店收益记录'
      }
    },
    {
      path: '/agent',
      name: 'agent',
      component: () => import('@/views/agent/index'),
      meta: {
        title: '经销商工作台'
      }
    },
    {
      path: '/agent/deductionRecord',
      name: 'deductionRecord',
      component: () => import('@/views/agent/deduction-record'),
      meta: {
        title: '经销商核销统计'
      }
    },
    {
      path: '/agent/deductionInfo',
      name: 'deductionInfo',
      component: () => import('@/views/agent/deduction-info'),
      meta: {
        title: '经销商往期抵扣明细'
      }
    },
    {
      path: '/salesmanremit',
      name: 'salesmanremit',
      component: () => import('@/views/agent/salesman-remit'),
      meta: {
        title: '业务员业绩查看'
      }
    },
    {
      path: '/marchantslist',
      name: 'marchantslist',
      component: () => import('@/views/agent/marchants-list'),
      meta: {
        title: '门店扫码统计'
      }
    },
    {
      path: '/marchantssancode',
      name: 'marchantssancode',
      component: () => import('@/views/agent/marchants-sancode'),
      meta: {
        title: '门店扫码明细'
      }
    },
    {
      path: '/salesmanregister',
      name: 'salesmanregister',
      component: () => import('@/views/login/salesman-register'),
      meta: {
        title: '业务员注册'
      }
    },
    {
      path: '/userintegral',
      name: 'userintegral',
      component: () => import('@/views/user/user-integral'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/userintegralinfo',
      name: 'userintegralinfo',
      component: () => import('@/views/user/user-integral-info'),
      meta: {
        title: '获取记录'
      }
    },
    {
      path: '/firmshops',
      name: 'firmshops',
      component: () => import('@/views/shops/firm-shops'),
      meta: {
        title: '鸡公山酒业'
      }
    },
    {
      path: '/shopinfo',
      name: 'shopinfo',
      component: () => import('@/views/shops/shop-info'),
      meta: {
        title: '奖品兑换'
      }
    },
    {
      path: '/prizeconfirmxj',
      name: 'prizeconfirmxj',
      component: () => import('@/views/merchants-page/prize-confirm-xj'),
      meta: {
        title: '星级酒系列'
      }
    },
    {
      path: '/prizeremit',
      name: 'prizeremit',
      component: () => import('@/views/salesman/prize-remit'),
      meta: {
        title: '积分兑奖审核'
      }
    },
    {
      path: '/prizeremit2',
      name: 'prizeremit2',
      component: () => import('@/views/salesman/prize-remit2'),
      meta: {
        title: '积分兑奖审核'
      }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/salesman/products'),
      meta: {
        title: '选择返货店铺'
      }
    },
    {
      path: '/productBox',
      name: 'productBox',
      component: () => import('@/views/salesman/productBox'),
      meta: {
        title: '扫码出库'
      }
    },
    {
      path: '/completepage',
      name: 'completepage',
      component: () => import('@/views/salesman/complete-page'),
      meta: {
        title: '出库完成'
      }
    },
    {
      path: '/barsrecord',
      name: 'barsrecord',
      component: () => import('@/views/salesman/bars-record'),
      meta: {
        title: '发货记录'
      }
    },
    {
      path: '/inspector',
      name: 'inspector',
      component: () => import('@/views/inspector/index'),
      meta: {
        title: '督导员工作台'
      }
    },
    {
      path: '/producttrace',
      name: 'producttrace',
      component: () => import('@/views/inspector/productTrace'),
      meta: {
        title: '流程追溯'
      }
    },
    {
      path: '/awardactivity',
      name: 'awardactivity',
      component: () => import('@/views/award-activity'),
      meta: {
        title: '模板活动主页'
      }
    },
    {
      path: '/awardactivity/postalact',
      name: 'postalact',
      component: () => import('@/views/award-activity/award-customization/postal-act'),
      meta: {
        title: '绵阳邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactwj',
      name: 'postalactwj',
      component: () => import('@/views/award-activity/award-customization/postal-act-wj'),
      meta: {
        title: '温江邮储活动主页'
      }
    },
    {
      path: '/awardactivity/wineactjgs',
      name: 'wineactjgs',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/postalactdy',
      name: 'postalactdy',
      component: () => import('@/views/award-activity/award-customization/postal-act-dy'),
      meta: {
        title: '德阳邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactgz',
      name: 'postalactgz',
      component: () => import('@/views/award-activity/award-customization/postal-act-gz'),
      meta: {
        title: '甘孜邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactzy',
      name: 'postalactzy',
      component: () => import('@/views/award-activity/award-customization/postal-act-zy'),
      meta: {
        title: '资阳邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactab',
      name: 'postalactab',
      component: () => import('@/views/award-activity/award-customization/postal-act-ab'),
      meta: {
        title: '阿坝邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactmy2',
      name: 'postalactmy2',
      component: () => import('@/views/award-activity/award-customization/postal-act-my2'),
      meta: {
        title: '绵阳邮储活动主页'
      }
    },
    {
      path: '/awardactivity/postalactyb',
      name: 'postalactyb',
      component: () => import('@/views/award-activity/award-customization/postal-act-yb'),
      meta: {
        title: '宜宾邮储活动主页'
      }
    },
    {
      path: '/loginwechat',
      name: 'loginwechat',
      component: () => import('@/views/login/wechat-login'),
      meta: {
        title: '微信登录'
      }
    },
    {
      path: '/merchantsnew',
      name: 'merchantsnew',
      component: () => import('@/views/merchants-page-new'),
      meta: {
        title: '我的门店'
      }
    },
    {
      path: '/consuactivelist',
      name: 'consuactivelist',
      component: () => import('@/views/merchants-page-new/consu-active-list'),
      meta: {
        title: '我的门店'
      }
    },
    {
      path: '/myearningsnew',
      name: 'myearningsnew',
      component: () => import('@/views/merchants-page-new/my-earnings'),
      meta: {
        title: '销售信息'
      }
    },
    {
      path: '/prizeconfirm2',
      name: 'prizeconfirm2',
      component: () => import('@/views/merchants-page-new/actives/prize-confirm2'),
      meta: {
        title: '门店活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs2',
      name: 'wineactjgs2',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs2'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/userintegralnew',
      name: 'userintegralnew',
      component: () => import('@/views/merchants-page-new/user-integral'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/awardactivity/postalacttfxq',
      name: 'postalacttfxq',
      component: () => import('@/views/award-activity/award-customization/postal-act-tfxq'),
      meta: {
        title: '天府新区邮储活动主页'
      }
    },
    {
      path: '/awardactivity/wineactjgs3',
      name: 'wineactjgs3',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs3'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/merchantspage/awardrecord',
      name: 'awardrecord',
      component: () => import('@/views/merchants-page/award-record'),
      meta: {
        title: '消费者领奖记录'
      }
    },
    {
      path: '/awardactivity/collection',
      name: 'collecion',
      component: () => import('@/views/award-activity/award-customization/collection'),
      meta: {
        title: '支付'
      }
    },
    {
      path: '/viewshopsexchange',
      name: 'viewshopsexchange',
      component: () => import('@/views/agent/view-shops-exchange'),
      meta: {
        title: '消费者核销记录'
      }
    },
    {
      path: '/userprizes',
      name: 'userprizes',
      component: () => import('@/views/user/user-prizes'),
      meta: {
        title: '消费者中奖记录'
      }
    },
    {
      path: '/awardactivity/wineactjgs4',
      name: 'wineactjgs4',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs4'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs4b',
      name: 'wineactjgs4b',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs4b'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs5',
      name: 'wineactjgs5',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs5'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs6',
      name: 'wineactjgs5',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs6'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs7',
      name: 'wineactjgs5',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs7'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactyan',
      name: 'wineactyan',
      component: () => import('@/views/award-activity/award-customization/wine-act-yan'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/awardactivity/wineactyan2',
      name: 'wineactyan2',
      component: () => import('@/views/award-activity/award-customization/wine-act-yan2'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/prizeconfirm3',
      name: 'prizeconfirm3',
      component: () => import('@/views/merchants-page-new/actives/prize-confirm3'),
      meta: {
        title: '门店活动'
      }
    },
    {
      path: '/awardactivity/wineactjgs8',
      name: 'wineactjgs8',
      component: () => import('@/views/award-activity/award-customization/wine-act-jgs8'),
      meta: {
        title: '鸡公山活动'
      }
    },
    {
      path: '/inquiresds',
      name: 'inquiresds',
      component: () => import('@/views/inquire-page-sds'),
      meta: {
        title: '防伪溯源'
      }
    },
    {
      path: '/inquirezsjy',
      name: 'inquirezsjy',
      component: () => import('@/views/inquire-page-zsjy'),
      meta: {
        title: '防伪溯源'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js